// TODO: unit test
const nonDeletedGender = ['male', 'female'];

const checkGender = val => nonDeletedGender.some(item => val === item);

export default checkGender;
